import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useInventoryStore = create(
  persist(
    (set, get) => ({
      // Products
      products: [
        { id: 'prod_001', name: 'Ball Bearings', sku: 'SKU-2847', category: 'Components', quantity: 500, reorderLevel: 100, unitPrice: 12.50, supplier: 'Premier Logistics Co', status: 'in_stock' },
        { id: 'prod_002', name: 'Electrical Connectors', sku: 'SKU-1923', category: 'Connectors', quantity: 15, reorderLevel: 50, unitPrice: 25.00, supplier: 'Global Parts Supply', status: 'low_stock' },
        { id: 'prod_003', name: 'Power Supply Units', sku: 'SKU-5634', category: 'Power', quantity: 0, reorderLevel: 25, unitPrice: 85.00, supplier: 'Manufacturing Corp', status: 'out_of_stock' },
        { id: 'prod_004', name: 'Control Panel', sku: 'SKU-3421', category: 'Controls', quantity: 42, reorderLevel: 30, unitPrice: 150.00, supplier: 'Direct Distributors', status: 'in_stock' },
        { id: 'prod_005', name: 'LCD Display Module', sku: 'SKU-8765', category: 'Display', quantity: 200, reorderLevel: 50, unitPrice: 45.00, supplier: 'Premier Logistics Co', status: 'in_stock' },
      ],

      // Warehouses
      warehouses: [
        { id: 'wh_001', name: 'Main Warehouse', location: 'San Francisco, CA', capacity: 50000, currentLoad: 35000, zones: 12, manager: 'John Smith' },
        { id: 'wh_002', name: 'East Coast Hub', location: 'New York, NY', capacity: 30000, currentLoad: 22000, zones: 8, manager: 'Jane Doe' },
        { id: 'wh_003', name: 'Chicago Distribution', location: 'Chicago, IL', capacity: 20000, currentLoad: 15000, zones: 6, manager: 'Mike Johnson' },
        { id: 'wh_004', name: 'West Coast Storage', location: 'Los Angeles, CA', capacity: 25000, currentLoad: 18000, zones: 7, manager: 'Sarah Williams' },
      ],

      // Purchase Orders
      purchaseOrders: [
        { id: 'po_001', poNumber: 'PO-2026-001', supplier: 'Premier Logistics Co', orderDate: '2026-04-25', expectedDelivery: '2026-05-02', status: 'pending', items: 50, totalValue: 1250.00 },
        { id: 'po_002', poNumber: 'PO-2026-002', supplier: 'Global Parts Supply', orderDate: '2026-04-26', expectedDelivery: '2026-04-30', status: 'shipped', items: 100, totalValue: 2500.00 },
        { id: 'po_003', poNumber: 'PO-2026-003', supplier: 'Manufacturing Corp', orderDate: '2026-04-27', expectedDelivery: '2026-05-05', status: 'pending', items: 25, totalValue: 2125.00 },
        { id: 'po_004', poNumber: 'PO-2026-004', supplier: 'Direct Distributors', orderDate: '2026-04-20', expectedDelivery: '2026-04-28', status: 'delivered', items: 30, totalValue: 4500.00 },
      ],

      // Suppliers
      suppliers: [
        { id: 'sup_001', name: 'Premier Logistics Co', contact: 'John Contact', email: 'john@premierlogistics.com', phone: '+1-555-0100', rating: 98, onTime: 98, quality: 96, reliability: 97, status: 'active' },
        { id: 'sup_002', name: 'Global Parts Supply', contact: 'Jane Contact', email: 'jane@globalparts.com', phone: '+1-555-0101', rating: 93, onTime: 94, quality: 92, reliability: 93, status: 'active' },
        { id: 'sup_003', name: 'Manufacturing Corp', contact: 'Mike Contact', email: 'mike@manufacturing.com', phone: '+1-555-0102', rating: 90, onTime: 91, quality: 89, reliability: 90, status: 'active' },
        { id: 'sup_004', name: 'Direct Distributors', contact: 'Sarah Contact', email: 'sarah@directdist.com', phone: '+1-555-0103', rating: 86, onTime: 87, quality: 85, reliability: 86, status: 'active' },
      ],

      // Shipments
      shipments: [
        { id: 'ship_001', trackingNumber: 'TRACK-001', supplier: 'Premier Logistics Co', origin: 'San Francisco, CA', destination: 'New York, NY', status: 'in_transit', departureDate: '2026-04-26', expectedArrival: '2026-05-02', items: 50, weight: '500 lbs' },
        { id: 'ship_002', trackingNumber: 'TRACK-002', supplier: 'Global Parts Supply', origin: 'Chicago, IL', destination: 'Los Angeles, CA', status: 'in_transit', departureDate: '2026-04-25', expectedArrival: '2026-04-30', items: 100, weight: '800 lbs' },
        { id: 'ship_003', trackingNumber: 'TRACK-003', supplier: 'Manufacturing Corp', origin: 'Dallas, TX', destination: 'San Francisco, CA', status: 'delivered', departureDate: '2026-04-20', expectedArrival: '2026-04-26', items: 75, weight: '600 lbs' },
      ],

      // Alerts
      alerts: [
        { id: 'alert_001', item: 'SKU-2847 - Ball Bearings', alert: 'Low stock - 15 units left', priority: 'CRITICAL', createdAt: '2026-04-28' },
        { id: 'alert_002', item: 'SKU-1923 - Electrical Connectors', alert: 'Expected shortage in 3 days', priority: 'HIGH', createdAt: '2026-04-27' },
        { id: 'alert_003', item: 'SKU-5634 - Power Supply Units', alert: 'Supplier delay reported', priority: 'HIGH', createdAt: '2026-04-26' },
        { id: 'alert_004', item: 'SKU-3421 - Control Panel', alert: 'Below reorder point', priority: 'MEDIUM', createdAt: '2026-04-25' },
      ],

      // Product Actions
      addProduct: (product) => set((state) => ({
        products: [...state.products, { ...product, id: `prod_${Date.now()}` }]
      })),

      updateProduct: (id, product) => set((state) => ({
        products: state.products.map(p => p.id === id ? { ...p, ...product } : p)
      })),

      deleteProduct: (id) => set((state) => ({
        products: state.products.filter(p => p.id !== id)
      })),

      getProductById: (id) => get().products.find(p => p.id === id),

      // Warehouse Actions
      addWarehouse: (warehouse) => set((state) => ({
        warehouses: [...state.warehouses, { ...warehouse, id: `wh_${Date.now()}` }]
      })),

      updateWarehouse: (id, warehouse) => set((state) => ({
        warehouses: state.warehouses.map(w => w.id === id ? { ...w, ...warehouse } : w)
      })),

      deleteWarehouse: (id) => set((state) => ({
        warehouses: state.warehouses.filter(w => w.id !== id)
      })),

      // Purchase Order Actions
      addPurchaseOrder: (order) => set((state) => ({
        purchaseOrders: [...state.purchaseOrders, { ...order, id: `po_${Date.now()}`, orderDate: new Date().toISOString().split('T')[0] }]
      })),

      updatePurchaseOrder: (id, order) => set((state) => ({
        purchaseOrders: state.purchaseOrders.map(o => o.id === id ? { ...o, ...order } : o)
      })),

      deletePurchaseOrder: (id) => set((state) => ({
        purchaseOrders: state.purchaseOrders.filter(o => o.id !== id)
      })),

      // Supplier Actions
      addSupplier: (supplier) => set((state) => ({
        suppliers: [...state.suppliers, { ...supplier, id: `sup_${Date.now()}`, status: 'active' }]
      })),

      updateSupplier: (id, supplier) => set((state) => ({
        suppliers: state.suppliers.map(s => s.id === id ? { ...s, ...supplier } : s)
      })),

      deleteSupplier: (id) => set((state) => ({
        suppliers: state.suppliers.filter(s => s.id !== id)
      })),

      // Shipment Actions
      addShipment: (shipment) => set((state) => ({
        shipments: [...state.shipments, { ...shipment, id: `ship_${Date.now()}` }]
      })),

      updateShipment: (id, shipment) => set((state) => ({
        shipments: state.shipments.map(s => s.id === id ? { ...s, ...shipment } : s)
      })),

      deleteShipment: (id) => set((state) => ({
        shipments: state.shipments.filter(s => s.id !== id)
      })),

      // Alert Actions
      addAlert: (alert) => set((state) => ({
        alerts: [...state.alerts, { ...alert, id: `alert_${Date.now()}`, createdAt: new Date().toISOString().split('T')[0] }]
      })),

      deleteAlert: (id) => set((state) => ({
        alerts: state.alerts.filter(a => a.id !== id)
      })),

      // Statistics
      getTotalProducts: () => get().products.length,
      getLowStockCount: () => get().products.filter(p => p.status === 'low_stock').length,
      getOpenOrdersCount: () => get().purchaseOrders.filter(p => p.status === 'pending').length,
      getSuppliersCount: () => get().suppliers.filter(s => s.status === 'active').length,
      getInTransitCount: () => get().shipments.filter(s => s.status === 'in_transit').length,
    }),
    {
      name: 'inventory-store',
      getStorage: () => localStorage,
    }
  )
)
